{
    "PoundUkStd": "£ - Livre sterling",
    "PoundUkIso": "GBP - Livre sterling britannique",
    "DollarUsaStd": "$ - Dollar américain",
    "DollarUsaOther": "US$ - Dollar des États-Unis",
    "DollarUsaIso": "USD - Dollar des États-Unis",
    "DollarCanadaEnglishStd": "$ - Dollar canadien (anglais)",
    "DollarCanadaEnglishOther": "C$ - Dollar canadien (anglais)",
    "DollarCanadaFrenchStd": "$ - Dollar canadien (français)",
    "DollarCanadaFrenchOther": "C$ - Dollar canadien (français)",
    "DollarCanadaIso": "CAD - Dollar canadien",
    "DollarAustraliaStd": "$ - Dollar australien",
    "DollarAustraliaOther": "A$ - Dollar australien",
    "DollarAustraliaIso": "AUD - Dollar australien",
    "DollarNewzealandStd": "$ - Dollar néo-zélandais",
    "DollarNewzealandOther": "NZ$ - Dollar néo-zélandais",
    "DollarNewzealandIso": "NZD - Dollar néo-zélandais",
    "DollarSingaporeStd": "$ - Dollar de Singapour",
    "DollarSingaporeOther": "S$ - Dollar de Singapour",
    "DollarSingaporeIso": "SGD - Dollar de Singapour",
    "DollarHongkongStd": "$ - Dollar de Hong Kong",
    "DollarHongkongOther": "HK$ - Dollar de Hong Kong",
    "DollarHongkongIso": "HKD - Dollar de Hong Kong",
    "EuroGeneralStd": "€ - Euro (général)",
    "EuroFrenchStd": "€ - Euro (français)",
    "EuroGermanStd": "€ - Euro (allemand)",
    "EuroItalianStd": "€ - Euro (italien)",
    "EuroIso": "EUR - Euro",
    "YenJapanStd": "¥ - Yen japonais",
    "YenJapanIso": "JPY - Yen japonais",
    "FrancSchwitzerlandFrenchStd": "fr. - Franc suisse (français)",
    "FrancSchwitzerlandGermanStd": "Fr. - Franc suisse (allemand)",
    "FrancSchwitzerlandItalianStd": "fr. - Franc suisse (italien)",
    "FrancSchwitzerlandIso": "CHF - Franc suisse",
    "YuanChinaStd": "¥ - Yuan chinois Renminbi",
    "YuanChinaIso": "CNY - Yuan chinois Renminbi",
    "PesoMexicoStd": "$ - Peso mexicain",
    "PesoMexicoIso": "MXN - Peso mexicain",
    "KronaSwedenStd": "kr - Couronne suédoise",
    "KronaSwedenIso": "SEK - Couronne suédoise",
    "KroneNorwayStd": "kr - Couronne norvégienne",
    "KroneNorwayIso": "NOK - Couronne norvégienne",
    "WonSouthkoreaStd": "₩ - Won sud-coréen",
    "WonSouthkoreaIso": "KRW - Won sud-coréen",
    "LiraTurkeyStd": "₺ - Lira turque",
    "LiraTurkeyIso": "TRY - Lira turque",
    "RupeeIndiaStd": "₹ - Roupie indienne",
    "RupeeIndiaIso": "INR - Roupie indienne",
    "RupleRussiaStd": "₽ - Rouble russe",
    "RupleRussiaIso": "RUB - Rouble russe",
    "RealBrazilStd": "R$ - Real brésilien",
    "RealBrazilIso": "BRL - Real brésilien",
    "RandSouthafricaStd": "R - Rand sud-africain",
    "RandSouthafricaIso": "ZAR - Rand sud-africain",
    "NAME": "Currency"
}